import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { intl } from '../../../../modules/Intl/IntlGlobalWrapper';
import textUtils from '../../../../util/text';
import { saveConfig, updateTimeUnit } from '../../FilterActions';
import RadioButton from '../../../RadioButton/RadioButton';

class TimeUnitBreakdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [
        { label: 'Day', value: 'day' },
        { label: 'Week', value: 'week' },
        { label: '2 weeks', value: '2weeks' },
        { label: 'Month', value: 'month' },
      ],
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value != this.props.value) {
      this.setState({
        value: this.props.value,
      });
    }
  }

  handleChange = (selected) => {
    this.props.updateValue(selected.value, this.props.chart);
    this.props.saveConfig();
  };

  render() {
    const listRenderer = () => {
      return this.state.items.map((item, i) => {
        return (
          <RadioButton
            id={i}
            key={i}
            name={item.label}
            label={item.label}
            value={item.value}
            checked={item.value === this.props.value}
            onChange={this.handleChange}
          />
        );
      });
    };

    return (
      <div>
        <RadioButton
          id={`${this.props.app}.card`}
          name={`${this.props.app}.card`}
          label={textUtils.format(intl.formatMessage({ id: `${this.props.app}.card` }), '', true, false, 'capitalize')}
          value={'cards'}
          checked={this.props.value === 'cards'}
          onChange={this.handleChange}
        />
        <RadioButton
          id="time"
          name="time"
          label={'Time'}
          value={'day'}
          checked={this.props.value !== 'cards'}
          onChange={this.handleChange}
        />

        {this.props.value !== 'cards' && <div className="sublevel">{listRenderer()}</div>}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateValue: (val, chart) => dispatch(updateTimeUnit(val, chart)),
  };
};

const mapStateToProps = (state) => {
  let chart = state.filters.chart;
  return {
    app: state.app.app,
    userConfig: state.auth.user.config,
    chart,
    value: state.filters[chart].timeUnit,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(TimeUnitBreakdown);
export { connected as TimeUnitBreakdown };
